import { TFunction } from "react-i18next";

export const getISODate = () => {
  const date = new Date();
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0];
  return dateString; // YYYY-MM-DD
};

export const secToTime = function (value: number) {
  const seconds = value % 60;
  const minutes = (value - seconds) / 60;
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const timeToSec = function (value: string) {
  const trimmed = value?.trim();
  if (!trimmed) return 0;
  const parts = trimmed.split(":");
  return Number(parts[0]) * 60 + Number(parts[1]) * 1;
};

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone?.replace("Europe/Kyiv", "Europe/Kiev");
};

export const formatCardReturnTime = (waitingSeconds: number, locale: string, t: TFunction): string => {
  const returnDate = new Date(Date.now() + waitingSeconds * 1000);
  const now = new Date();

  const start = t("Hidden until:") + " ";

  // Get today's midnight
  const todayMidnight = new Date(now);
  todayMidnight.setHours(24, 0, 0, 0);

  // Get tomorrow's midnight
  const tomorrowMidnight = new Date(todayMidnight);
  tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);

  if (returnDate < todayMidnight) {
    // Format as HH:MM
    return start + returnDate.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  } else if (returnDate < tomorrowMidnight) {
    return start + t("tomorrow");
  } else {
    // Format as short date
    return start + returnDate.toLocaleDateString(locale, { year: "numeric", month: "numeric", day: "numeric" });
  }
};
